function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-1f37867b\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./projects.vue")
}
var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./projects.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1f37867b\",\"hasScoped\":true}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./projects.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1f37867b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/main/projects/projects.vue
// module id = 278
// module chunks = 0